export default "__VITE_ASSET__CecMyKaQ__"